let API_BASE_URL;
let IMAGE_BASE_URL;

if(!document.querySelector('meta[name="APID_URL"]')?.getAttribute('content').includes("http")){
    API_BASE_URL = 'https://apid02.toytrade.pk'
}
else{
    API_BASE_URL = document.querySelector('meta[name="APID_URL"]')?.getAttribute('content');
} 
 

if(!document.querySelector('meta[name="IMG_URL"]')?.getAttribute('content').includes("http")){

    IMAGE_BASE_URL = 'https://images02.toytrade.pk'
}
else{
    IMAGE_BASE_URL = document.querySelector('meta[name="IMG_URL"]')?.getAttribute('content');
} 

export { API_BASE_URL, IMAGE_BASE_URL };